import { render, staticRenderFns } from "./CommonIcon.vue?vue&type=template&id=117ce8c3"
import script from "./CommonIcon.vue?vue&type=script&lang=js"
export * from "./CommonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports